import { useEffect, useState } from "react";

interface MaintenanceOverlayProps {
  onDismiss: () => void;
}

function MaintenanceOverlay({ onDismiss }: MaintenanceOverlayProps) {
  const [typedKeys, setTypedKeys] = useState("");

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const newTyped = (typedKeys + event.key).slice(-6);
      setTypedKeys(newTyped);

      if (newTyped === "qwerty") {
        onDismiss();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [typedKeys, onDismiss]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/95 backdrop-blur-sm">
      <div className="max-w-lg mx-4 text-center">
        <img
          src="/logo512.png"
          alt="Police Narratives AI"
          className="w-32 h-32 mx-auto mb-8 opacity-90"
        />
        <h1 className="text-2xl font-semibold text-white mb-4">
          System Update in Progress
        </h1>
        <p className="text-slate-300 text-lg leading-relaxed mb-6">
          We're pushing important updates to improve your experience. Please use
          an external recorder or department-issued device to capture any
          narratives during this time.
        </p>
        <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700">
          <p className="text-slate-400 text-sm">
            Estimated time to completion:{" "}
            <span className="text-white font-medium">~30 minutes</span>
          </p>
        </div>
        <p className="text-slate-500 text-sm mt-6">
          Thank you for your patience.
        </p>
      </div>
    </div>
  );
}

export default MaintenanceOverlay;
